import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { composeFormData } from '@/utils'

import { Trainer, useInvalidateTrainers } from './get-trainers'

export type TrainerServicePayload = {
  fee: number
  percentage: number
  // Note: BE identifies the service by its training type name
  serviceId: string
}

// Note: street, apartment and zipCode are deliberately absent - BE ignores them on create
export type CreateTrainerRequest = {
  avatar?: File
  email: string
  firstName: string
  gender: string
  lastName: string
  phone: string
  services: TrainerServicePayload[]
}

export const createTrainer = async (data: CreateTrainerRequest) => {
  const response = await authAPI.post<Trainer>('/trainer', composeFormData(data), {
    headers: { 'content-type': 'multipart/form-data' },
  })
  return response.data
}

export const useCreateTrainer = () => {
  const invalidateTrainers = useInvalidateTrainers()

  return useMutation({
    mutationFn: createTrainer,
    onSuccess: invalidateTrainers,
  })
}
